<template>
    <div>

        <div class="supply-container" style="background-color: #e1e4e7;
    position: fixed;
    left: 15px;
    top: calc(55px + 4rem);
    width: 20%;
    padding: .5rem;
    z-index: 9999;
    height: 90%;">
            <h5>محصولات</h5>
            <hr>
            <div style="position: relative; overflow-y: scroll; height: inherit;">
                <div class="row">
                    <div class="col-6 text-right font-weight-bold">محصول</div>
                    <div class="col-6 text-center font-weight-bold">تعداد سفارش</div>
                </div>
                <hr>
                <i v-if="products == null || products[0] === undefined" class="fa fa-2x fa-spinner fa-spin"></i>
                <div v-else @click="getProductOrdersList(product.product.id)" v-for="product in products" class="row" style="border-bottom: 1px solid black; padding: .5rem 0; cursor: pointer;">
                    <div class="col-6 text-right">
                        <h6 class="m-0">{{ product.product.name }}</h6>
                    </div>
                    <div class="col-6 text-center">
                        <h6 class="m-0">{{ product.unitVal }}</h6>
                    </div>
                </div>
                <div style="height: 10%"></div>
            </div>
        </div>
        <div @click="openSelectedProductPanel" id="myAnimation"  style="cursor: pointer; background-color: white;
    position: fixed;
    left: 22%;
    top: calc(55px + 4rem);
    width: 20%;
    padding: 1rem;
    z-index: 9999;
    height: 90%;
    border-radius: .4rem;
box-shadow: rgba(12, 13, 14, 0.25) -1px -1px 20px 0, rgba(59, 64, 69, 0.12) 0 1px 6px">
            <div style="text-align: center">
                <i v-if="selectedProductIsShown" class="fa fa-chevron-down"></i>
                <i v-else class="fa fa-chevron-up"></i>
                <h6 style="margin-top: .1rem; color: black;">محصول انتخابی:</h6>
            </div>
            <br>
            <div class="row">
                <div class="col-12">
                    <h5 class="text-right blue">{{ data.product.name }}</h5>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-12 text-center">
                    <h5 style="color: black;">موجودی انبار:</h5>
                    <h5 style="color: black;"><span v-if="data.product.fullRequirement <= data.product.stock" style="margin-left: .3rem;"><i class="fa fa-check green"></i></span><span>{{ data.product.stock }}</span>/<span :class="{'red': data.product.fullRequirement > data.product.stock, 'green': data.product.fullRequirement <= data.product.stock }">{{ data.product.fullRequirement }}</span></h5>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-12">
                    <div class="row" v-for="item in data.materials">
                        <div class="col-6 text-right">
                            <h6 style="color: black;">{{ item.name }}</h6>
                        </div>
                        <div class="col-6 text-left">
                            <h6 style="color: black;">{{ item.fullRequirement }}/{{ item.stock }} کل</h6>
                        </div>
                    </div>
                </div>
              <div>

              </div>
            </div>
        </div>
        <div class="scrolling-wrapper row" id="bottomScrollingWrapper" style="width: calc(100% - 20%); margin-right: 0px">
            <draggable class="row" style="flex-wrap: nowrap; width: 100%;" v-model="data.customers" :options="{group: 'companies', draggable: '.draggable-card', dragClass: 'drag-handler', scrollSensitivity: 200}" @end="onDragEnd">
                <order-col class="col-3 draggable-card" v-for="customer in data.customers" :key="customer.id" :customer="customer" :product="data.product" :materials="customer.materials" style="background-color: #cecece59; !important; height: 100vh; overflow-y: scroll;" />
            </draggable>
        </div>

        <!--<div v-if="data.customers == null || data.customers[0] === undefined" class="d-flex justify-content-center align-items-center">-->
            <!--<i class="fa fa-2x fa-spinner fa-spin"></i>-->
        <!--</div>-->
        <div v-if="data.customers == null || data.customers[0] === undefined" class="d-flex justify-content-center align-items-center">
            <span>سفارش باز موجود نیست کلیه سفارشات انجام شده است</span>
        </div>

        <div class="scrolling-wrapper" id="topScrollingWrapper" style="width: calc(100% - 20%); margin-right: calc(15px + 20%)">
            <div class="col-3" v-for="category in data.customers"></div>
        </div>

    </div>
</template>

<script>
    import * as $ from 'jquery';
    import draggable from 'vuedraggable';
    import OrderCol from "../components/production-management/OrderCol.vue";
    import anime from 'animejs';
    import BaseService from '../_framework/api/BaseService.js';
    import EventBus from '../_framework/bus.js';

    export default {
        name: 'supply',
        components: {
            OrderCol,
            draggable
        },
        data() {
            return {
                originalData: {},
                products: [],
                data: {
                    product: {
                        name: '',
                        stock: 0
                    }
                },
                selectedProductIsShown: true,
            };
        },
        mounted() {
            $('#topScrollingWrapper').scroll(function() {
                $('.scrolling-wrapper').scrollLeft($(this).scrollLeft());
            });
            $('#bottomScrollingWrapper').scroll(function() {
                $('.scrolling-wrapper').scrollLeft($(this).scrollLeft());
            });

            this.getProductOrdersList(this.$route.params.id, false);

            this.getAllProducts();
        },
        methods: {
            getProductOrdersList(id, toggleProductPanel = true) {
                this.data = {
                    product: {
                        name: '',
                        stock: 0
                    }
                };
                new BaseService('ProductionManagements', '/getCompareCustomersOrder/' + id).getList().then((response) => {
                    this.originalData = response.data;

                    this.data = this.calculateData(this.originalData);
                    // console.log(this.data)
                    if(toggleProductPanel) {
                        this.openSelectedProductPanel();
                    }
                }).catch((error) => {

                }).then(() => {

                });
            },
            getAllProducts() {
                new BaseService('ProductionManagements', '/getProducts/').getList().then((response) => {
                    this.products = response.data;
                }).catch((error) => {

                }).then(() => {

                });
            },
            onDragEnd(e) {
                this.data = this.calculateData(this.data);
                EventBus.$emit('rerenderCol');
            },
            calculateData(data) {
                data.product.leftStock = data.product.stock;
                data.product.fullRequirement = 0;

                for(let material of data.materials) {
                    material.leftStock = material.stock;
                    material.fullRequirement = 0;
                }

                for(let customer of data.customers) {
                    let assignable = 0;
                    if(data.product.leftStock < customer.unitVal) {
                        // not enough prod in stock
                        assignable = data.product.leftStock;
                    } else {
                        assignable = customer.unitVal;
                    }

                    customer.assigned = assignable;
                    data.product.leftStock -= assignable;
                    data.product.fullRequirement += customer.unitVal;

                    customer.materials = JSON.parse(JSON.stringify(data.materials));
                    let lackingProductsCount = customer.unitVal - customer.assigned;

                    for(let j = 0; j < customer.materials.length; j++) {
                        data.materials[j].fullRequirement += customer.unitVal * data.materials[j].percentage;
                        let requiredLackingMaterial = lackingProductsCount * data.materials[j].percentage;
                        let assignable = 0;
                        if(data.materials[j].leftStock < requiredLackingMaterial) {
                            // out of stock
                            assignable = data.materials[j].leftStock;
                        } else {
                            assignable = requiredLackingMaterial;
                        }

                        customer.materials[j].requiredMaterial = requiredLackingMaterial;
                        data.materials[j].leftStock -= assignable;
                        customer.materials[j].assignable = assignable;
                    }
                }

                return data;
            },
            openSelectedProductPanel() {
                let self = this;
                anime({
                    targets: '#myAnimation',
                    translateY: self.selectedProductIsShown ? (document.documentElement.scrollHeight / 1.6) : 0,
                    elasticity: 0,
                    duration: 500,
                    loop: false,
                    complete: function(anim) {
                        self.selectedProductIsShown = !self.selectedProductIsShown;
                    }
                });
            }
        }
    }
</script>

<style lang="scss">
    .red {
        color: #ff8585;
    }

    .green {
        color: #19be5d;
    }

    .blue {
        color: #3e64ff;
    }

    .scrolling-wrapper {
        width: 100%;
        left: 0;
        right: 0;
        display: flex;
        flex-wrap: nowrap;
        overflow-x: auto;
        flex-direction: row;
    }

    /*#bottomScrollingWrapper {*/
    /*margin: 0;*/

    /*&::-webkit-scrollbar {*/
    /*display: none;*/
    /*}*/
    /*}*/

    #topScrollingWrapper {
        position: fixed;
        bottom: 1rem;
        z-index: 500;
        opacity: .8;
    }

    .task-card {
        background-color: grey;
        color: white;
        border-radius: .4rem;
        padding: 2rem;
        margin: .5rem;
        box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
        transition: 0.3s;
        cursor: pointer;

        &:hover {
            background-color: #aaaaaa;
        }
    }

    .fadeoutTheBottom {
        position: absolute;
        margin-right: -15px;
        width: -moz-available;
        width: -webkit-fill-available;
        width: stretch;
        margin-left: -15px;
        bottom: 0;
        height: 50%;
        background: linear-gradient(rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
    }

    .draggable-card:first-child {
        margin-right: 1rem;
    }
</style>
